import React from 'react';
import { CheckCircle2Icon, DatabaseIcon, RefreshCwIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const benefits = [{
  icon: DatabaseIcon,
  title: 'Most comprehensive NYC accounting database',
  description: 'Access the largest database of accounting firms in New York City — 3,450+ CPA firms in Midtown, tax preparers in Brooklyn, bookkeepers in Queens, and forensic accountants across the Bronx and Staten Island.'
}, {
  icon: ShieldCheckIcon,
  title: 'Verified NYC accounting owner contacts',
  description: 'Get direct accounting email lists and phone numbers for CFOs, managing partners, and senior accountants in the NYC area. Our accounting owner database is verified in real-time for 97% accuracy.'
}, {
  icon: RefreshCwIcon,
  title: 'Weekly NYC database updates',
  description: 'Our New York City accounting business database is refreshed weekly with new CPA firms, updated owner contact information, and the latest business intelligence to keep your accounting email list current.'
}, {
  icon: ZapIcon,
  title: 'Built-in email sequencing',
  description: 'Launch multi-step email campaigns directly to NYC accounting owner contacts without exporting. Send personalized outreach to your bookkeeper and tax preparer email list with our built-in tools.'
}];
export function NYCAccountingValueProps() {
  return <section className="py-24 bg-white" data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-209">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-210">
            Why buy{' '}
            <span className="text-blue-600" data-id="element-211">
              New York City accounting leads
            </span>{' '}
            from Openmart?
          </h2>
          <p className="text-xl text-slate-600" data-id="element-212">
            The #1 local business email list for New York accounting firms —
            verified CPA, bookkeeper, and tax preparer owner contacts.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-213">
          {benefits.map(benefit => <div key={benefit.title} className="bg-slate-50 p-8 rounded-2xl border border-slate-200 hover:border-blue-300 hover:shadow-lg transition-all" data-id="element-214">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6 text-blue-600" data-id="element-215">
                <benefit.icon className="w-6 h-6" data-id="element-216" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-217">
                {benefit.title}
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-218">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}